<template>
  <div class="content">
    <div class="bodycontent">
      <div class="red_tips">提示：员工需先注册店铺会员，如果没有请先注册</div>
      <el-form
        :model="formData"
        ref="formData"
        label-width="180px"
        :rules="rules"
      >
        <el-form-item label="手机号码" prop="mobile">
          <el-input
            v-model="formData.mobile"
            class="input_box"
            :readonly="!if_add"
          ></el-input>
          <el-button style="margin-left:10px;" @click="judgeMobile()"
            >验证手机号</el-button
          >
          <el-button type="primary" @click="showScan()">注册码</el-button>
        </el-form-item>
        <el-form-item label="设置密码" prop="password">
          <el-input
            v-model="formData.password"
            class="input_box"
            type="password"
            show-password
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="重复密码" prop="repassword" >
          <el-input v-model="formData.repassword" class="input_box" type="password" show-password></el-input>
        </el-form-item> -->
        <el-form-item label="员工编号" prop="emp_no">
          <el-input v-model="formData.emp_no" class="input_box"></el-input>
        </el-form-item>
<!--        <el-form-item label="员工ID" prop="emp_no" v-if="$route.query.sid">-->
<!--          <el-input v-model="formData.id" class="input_box" disabled></el-input>-->
<!--          &lt;!&ndash; <div></div> &ndash;&gt;-->
<!--        </el-form-item>-->
        <el-form-item label="员工姓名" prop="name">
          <el-input v-model="formData.name" class="input_box"></el-input>
        </el-form-item>
        <el-form-item label="所属门店" prop="room_id">
          <el-select v-model="formData.room_id" placeholder="请选择门店">
            <el-option
              v-for="item in store_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="role_id">
          <el-select v-model="formData.role_id" placeholder="请选择角色">
            <el-option
              v-for="item in role_options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否副管理员">
          <el-checkbox v-model="formData.app_admin">副管理员</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="授权码" prop="reco_code">
          <el-input 
            v-model="formData.reco_code" 
            class="input_box_small" 
            maxlength="6"
            minlength="6"
            show-word-limit
            @keyup.native="UpNumber"
            @keydown.native="UpNumber"></el-input>
          <div class="tips">6位数字母和数字组合</div>
        </el-form-item> -->
<!--        <el-form-item label="提成规则">-->
<!--          <el-select v-model="formData.commission_id">-->
<!--            <el-option-->
<!--              v-for="item in commissionOption"-->
<!--              :key="item.id"-->
<!--              :value="item.id"-->
<!--              :label="item.name"-->
<!--            ></el-option>-->
<!--          </el-select>-->
<!--        </el-form-item>-->
      </el-form>
      <div class="bottom_btn">
        <el-button type="primary" @click="save">提交</el-button>
        <el-button @click="goback()">返回列表</el-button>
      </div>
    </div>
    <el-dialog :visible.sync="showQrcode" width="340px" title="扫码注册" @close="closeQrcode">
      <div class="qrcode-con" id="qrcode"></div>
    </el-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
import {
  commissionList,
  employeeBind,
  employeeDetail,
  employeeEdit,
  judgeUser,
  roleList,
  storeSelect
} from "@/api/employee";

export default {
  components: {},
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      formData: {},
      if_add: true, //是否是新增
      loading: false, //页面loading
      store_options: [], //门店选项
      role_options: [], //角色选项
      rules: {
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        repassword: [
          { required: true, message: "请输入密码", trigger: "blur" }
        ],
        emp_no: [
          { required: true, message: "请输入员工编号", trigger: "blur" }
        ],
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        room_id: [{ required: true, message: "请选择门店", trigger: "blur" }],
        role_id: [
          { required: true, message: "请选择员工角色", trigger: "blur" }
        ]
      },
      commissionOption: [], // 提成规则
      showQrcode: false, // 扫码注册弹窗
    };
  },
  methods: {
    init() {
      // this.role_options = [{id:'0',name:'普通员工'}]
      this.loading = true;
      storeSelect({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.store_options = res.data;
          this.loading = false;
          roleList({ token: this.token, app_id: this.app_id }).then(res2 => {
            if (res2.code == 200) {
              res2.data.forEach(item => {
                this.role_options.push(item);
              });
              this.initForm();
            } else {
              this.$message({
                type: "error",
                message: "获取角色列表失败，请刷新重试"
              });
            }
          });
        } else {
          this.$message({
            type: "error",
            message: "获取门店列表失败，请刷新重试"
          });
        }
      });
      commissionList({ token: this.token, app_id: this.app_id }).then(res => {
        if (res.code == 200) {
          this.commissionOption = res.data;
        }
      });
    },
    initForm() {
      if (this.$route.query.sid) {
        this.if_add = false;
        this.loading = true;
        var data = {
          token: this.token,
          app_id: this.app_id,
          emp_id: this.$route.query.sid
        };
        employeeDetail(data).then(res => {
          var edit = Object.assign({}, res.data);
          delete edit.create_time;
          delete edit.update_time;
          delete edit.username;
          delete edit.room;
          this.formData = Object.assign({}, edit);
          this.formData.app_admin = edit.app_admin == 1
          this.loading = false;
        });
      } else {
        this.formData = {};
      }
    },
    judgeMobile() {
      if (this.formData.mobile.split("").length == 11) {
        var judge = {
          token: this.token,
          app_id: this.app_id,
          mobile: this.formData.mobile
        };
        judgeUser(judge).then(res => {
          if (res.msg == "手机号已注册") {
            this.$message({
              type: "success",
              message: "已注册，可直接绑定为员工"
            });
          } else {
            this.$message("该手机号未注册，请先注册为会员！");
          }
        });
      } else {
        this.$message("请输入正确的手机号");
      }
    },
    //保存表单
    save() {
      this.$refs.formData.validate(valid => {
        if (valid) {
          var data = Object.assign({}, this.formData);
          data.app_admin = this.formData.app_admin?1:0
          data.token = this.token;
          data.app_id = this.app_id;
          console.log(data);
          if (this.if_add) {
            //新增
            // 先验证手机号是否注册过
            var judge = {
              token: this.token,
              app_id: this.app_id,
              mobile: this.formData.mobile
            };
            judgeUser(judge).then(res => {
              if (res.msg == "手机号已注册") {
                // 已有账号绑定为员工
                data.uid = res.data.uid;
                // delete data.password;
                delete data.repassword;
                console.log(data);
                employeeBind(data).then(res => {
                  if (res.code == 200) {
                    this.$message({
                      type: "success",
                      message: res.msg
                    });
                    this.goback();
                  } else {
                    this.$message({
                      type: "error",
                      message: res.msg
                    });
                  }
                });
              } else {
                this.$message("该手机号未注册，请先注册为会员！");
              }
            });
          } else {
            //修改
            if (data.password == "") {
              delete data.password;
            }
            employeeEdit(data).then(res => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: res.msg
                });
                this.goback();
              } else {
                this.$message({
                  type: "error",
                  message: res.msg
                });
              }
            });
          }
        }
      });
    },
    goback() {
      this.$router.go(-1);
    },
    UpNumber(e) {
      e.target.value = e.target.value.replace(/[\W]/g, "");
    },
    showScan(){
      this.showQrcode = true;
      var url = "https://jjtc.58zltc.com/viphome?appid="+localStorage.getItem('app_id')
      console.log(url)
      this.$nextTick(() => {
        let qrcode = new QRCode("qrcode", {
          width: 300,
          height: 300, // 高度
          text: url // 二维码内容
        });
      });
    },
    closeQrcode(){
      this.showQrcode = false;
      document.getElementById("qrcode").innerHTML = "";
      // setTimeout(() => {
      //   location.reload();
      // }, 100);
    }
  }
};
</script>
<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-top: 10px;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
</style>
<style lang="scss" scoped>
.content {
  padding: 10px 55px 30px 0;
  height: calc(100vh - 102px);
  .bodycontent {
    position: relative;
    padding: 27px;
    font-size: 14px;
    height: 96%;
    border: 1px solid #f1f1f1;
    box-shadow: 0 0 3px #f1f1f1;
    display: flex;
    flex-direction: column;
    overflow: auto;
    .input_box {
      width: 300px;
    }
    .tips {
      color: #888;
    }
    .red_tips {
      color: #f00;
      margin-left: 180px;
    }
    .input_box_small {
      width: 202px;
    }
    .state_text {
      color: #999;
      font-size: 12px;
      height: 20px;
      line-height: 30px;
    }
    .bottom_btn {
      margin-left: 180px;
      margin-top: 30px;
      .ml30 {
        margin-left: 30px;
      }
    }
  }
}
</style>
